import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import './designcss/blogscss.css';

//import BlogTemplate from "./components/blogtemplate";
import CurrentBlogTemplate from './components/currentblogs';
import BlogTemplate from "./components/blogtemplate";

const CreateBlogs = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ 
    title: "",
    date: "",
    author: "",
    content: "",
    image: null,
    password: "",
    category: "tech",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => setFormData(
    { ...formData, [e.target.name]: e.target.value }
  );
  
  const handleImageChange = (e) => setFormData(
    { ...formData, image: e.target.files[0] }
  );


  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    try {
                                            // https://albiemer.onrender.com
                                            // http://localhost:8000/check_password/
      const passwordResponse = await fetch("https://albiemer.onrender.com/api/check_password/", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({password: formData.password}),
      });

      const passwordData = await passwordResponse.json();

      if (!passwordResponse.ok || !passwordData.isValid){

        alert("Incorrect Password, Please try Again");
        setIsLoading(false);
        return;

      }

      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      formDataToSend.append("date", formData.date);
      formDataToSend.append("author", formData.author);
      formDataToSend.append("content", formData.content);
      formDataToSend.append("password", formData.password);
      formDataToSend.append("category", formData.category);

      if (formData.image) {

        try {
          const cloudinaryUrl = "https://api.cloudinary.com/v1_1/dywqyzge2/image/upload";
          //const cloudinaryUploadPreset = ""; // Replace with your preset name

          const cloudinaryFormData = new FormData();
          cloudinaryFormData.append("file", formData.image);
          cloudinaryFormData.append("upload_preset", "momoupload");

          // await sleep(2000);
          const cloudinaryResponse = await fetch(cloudinaryUrl, {
            method: "POST",
            body: cloudinaryFormData,
          });

          const cloudinaryData = await cloudinaryResponse.json();

          if (!cloudinaryResponse.ok){
            throw new Error("Image upload failed");
          }

          formDataToSend.append("image", cloudinaryData.secure_url); // Add the image URL

        } catch (error) {
          console.error("cloudinary upload failed:", error);
          alert("Image upload failed");
          return;
        }
      }
      
                                      // https://albiemer.onrender.com
                               // http://localhost:8000/api/blogs/
      const response = await fetch("https://albiemer.onrender.com/api/blogs/", {
        method: "POST",
        body: formDataToSend,
      });

      if (response.ok) {
        navigate("/blogs");
      } else {
        alert("Blog submission failed");
      }

      return (
        <>
          <div className="blogcontainer">
            <p>Loading... Wait for Redirecting</p>
          </div>
        </>);
        
    } catch (error) {
        console.error("Error submitting to Django:", error);
        alert("Failed to submit blog post. Please try again.");
    } finally {
        setIsLoading(false);
    }

  };

  return (
    <>
      <div className="form-container">
        <div className="form-card">
          <form onSubmit={handleSubmit}>
            <input type="text" name="title" placeholder="Title" value={formData.title} onChange={handleChange} required />
            <input type="date" name="date" value={formData.date} onChange={handleChange} required />
            <input type="text" name="author" placeholder="Author" value={formData.author} onChange={handleChange} required />
            
            {/* COMBO BOX */}
            <select 
              name="category" 
              value={formData.category} 
              onChange={handleChange} 
              required
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                background: "#fff",
                color: "#333"
              }}
            >
              <option value="tech">Tech / Electronics</option>
              <option value="non-tech">Personal / Others (Non-Tech)</option>
            </select>

            <input type="file" name="image" accept="image/*" onChange={handleImageChange} required />
            <textarea name="content" placeholder="Content" value={formData.content} onChange={handleChange} required />
            <input type="password" name="password" placeholder="Admin Password to Post Blog" value={formData.password} onChange={handleChange} required />
            <p>Password entered: {formData.password}</p> 
            <button type="submit">Submit</button>
          </form>
          {/*<img src={formData.image} alt="Preview" width="200" />*/}
          {isLoading && <div className="loading-spinner">Loading... Please wait</div>}
        </div>
      </div>
    </>
  );
};

const CurrentBlogs = () => (
  <>
    <div className="blogcontainer">  
          <CurrentBlogTemplate />
    </div>
  </>
);

const MyBlogs = () => (
  <>
  <div className="buttonblogcontainer">
    <div className="row">
      <div className="card">
        <Link to="/createnewblogs" style={{ textDecoration: "none", display: "block", marginTop: "20px" }}>
          <button style={{
                          width: "100%",
                          padding: "12px",
                          background: "#000",
                          color: "cyan",
                          border: "none",
                          borderRadius: "8px",
                          fontWeight: "bold",
                          cursor: "pointer",
                          fontSize: "1rem"
                  }}>
                  Create Blogs Now
          </button>
        </Link>
      </div>
    </div>
  </div>
  <BlogTemplate/>
  </>
);

export { CreateBlogs, CurrentBlogs, MyBlogs };
